const formatters = {
  BRL: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency', maximumFractionDigits: 2 }),
  USD: new Intl.NumberFormat('pt-BR', { currency: 'USD', style: 'currency', maximumFractionDigits: 2 }),
  EUR: new Intl.NumberFormat('pt-BR', { currency: 'EUR', style: 'currency', maximumFractionDigits: 2 })
} as const

const smallFormatters = {
  BRL: new Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency', minimumSignificantDigits: 1, maximumFractionDigits: 2 }),
  USD: new Intl.NumberFormat('pt-BR', { currency: 'USD', style: 'currency', minimumSignificantDigits: 1, maximumFractionDigits: 2 }),
  EUR: new Intl.NumberFormat('pt-BR', { currency: 'EUR', style: 'currency', minimumSignificantDigits: 1, maximumFractionDigits: 2 })
} as const

export function formatCurrency (currency: keyof typeof formatters, value: number) {
  const isSmall = value < 1

  const formatter = isSmall
    ? smallFormatters[currency]
    : formatters[currency]

  const rounded = Number(value.toFixed(2))
  return formatter.format(rounded)
}
